export const NA = (genre = "M") => {
  let res = "Non mentionné";
  return genre === "M" ? res : res + "e";
};

export const getAccountType = () => {
  return [
    { code: 0, label: "Consultant Individuel" },
    { code: 1, label: "Association/Volontaire" },
    { code: 2, label: "AGEX/Cabinet" },
    { code: 3, label: "AGEX/Cabinet/Association/Volontaire" },
  ];
};

export const getAccountTypeNameByCode = (code) => {
  const accountType = getAccountType();
  return accountType.at(code).label;
}; 

export const getAccountTypeByCode = (code) => {
  const accountType = getAccountType();
  return accountType.at(code);
};
